export default function TrustSection() {
  return (
    <section id="reviews" className="w-full px-6 md:px-10 py-16 md:py-20 bg-background-100">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            Trusted Resource, Built for Smart Shoppers
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-xl mx-auto">
            We are committed to providing accurate, up-to-date, and genuinely helpful Basetao spreadsheet resources.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {[
            { icon: 'ri-shield-check-line', label: 'Verified Resources', desc: 'Curated and regularly updated' },
            { icon: 'ri-guide-line', label: 'Expert Guides', desc: 'Written by experienced shoppers' },
            { icon: 'ri-timer-line', label: 'Always Updated', desc: 'Latest 2026 information' },
            { icon: 'ri-user-heart-line', label: 'Community First', desc: 'Built for real shoppers' },
          ].map((item) => (
            <div key={item.label} className="flex flex-col items-center text-center p-6 rounded-xl bg-background-50 border border-background-200/70 transition-all duration-300 hover:border-primary-300/50">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100/70 text-primary-600 mb-3">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h4 className="font-heading text-sm font-semibold text-foreground-800 mb-1">{item.label}</h4>
              <p className="text-xs text-foreground-500">{item.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 p-6 rounded-xl bg-accent-50/50 border border-accent-200/50">
          <div className="flex items-start gap-3">
            <div className="w-6 h-6 flex-shrink-0 flex items-center justify-center mt-0.5">
              <i className="ri-information-line text-accent-600 text-lg"></i>
            </div>
            <div>
              <h4 className="font-heading text-sm font-semibold text-foreground-800 mb-2">Important Disclaimer</h4>
              <p className="text-xs text-foreground-600 leading-relaxed">
                This website provides educational information and resources about Basetao spreadsheets and related shopping tools. We are an independent resource hub and not directly affiliated with Basetao. Users should independently verify all product details, prices, and seller information before making any purchasing decisions. All external links to kaspreadsheet.com are provided for your convenience.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}